import React, { FC } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import useMainIsTop from 'src/hooks/useIsTop';

const useStyles = makeStyles({
  currentPage: {
    borderBottom: 'solid #262626 6px',
  },
});

const Root = styled('ul')({
  listStyleType: 'none',
  display: 'flex',
  justifyContent: 'flex-end',
  margin: 0,
});

const Item = styled('li')<{ color: string }>(({ color }) => ({
  fontSize: 22,
  fontWeight: 600,
  color,
  marginRight: 100,

  '&:last-child': {
    marginRight: 0,
  },

  '& a': {
    textDecoration: 'none',
  },
  '& a:visited': {
    textDecoration: 'none',
  },
  '& a:hover': {
    textDecoration: 'none',
  },
}));

const Menu: FC = () => {
  const classes = useStyles();
  const { isTop } = useMainIsTop();
  const data = useStaticQuery(graphql`
    query HeadingQuery {
      site {
        siteMetadata {
          menuLinks {
            name
            link
            external
          }
        }
      }
    }
  `);

  const shouldUseWhite =
    isTop &&
    typeof window !== 'undefined' &&
    window.location.pathname.length < 2;

  const color = shouldUseWhite ? '#ffffff' : '#262626';

  return (
    <Root>
      {data.site.siteMetadata.menuLinks.map(item => (
        <Item key={item.link} color={color}>
          {item.external ? (
            <a href={item.link} target="_blank" rel="noreferrer">
              {item.name}
            </a>
          ) : (
            <Link
              to={item.link}
              activeStyle={{
                borderBottom: 'solid #262626 6px',
                borderColor: shouldUseWhite ? '#fff' : '#262626',
              }}>
              {item.name}
            </Link>
          )}
        </Item>
      ))}
    </Root>
  );
};

export default Menu;
